import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface LabOrdersState {
  selectedTab: number
  successCount: number
  consultationType: string
  validatedOrderNumber: string
  triggerNotification: boolean
}

const initialState: LabOrdersState = {
  selectedTab: 0,
  successCount: 0,
  consultationType: 'OPD',
  validatedOrderNumber: '',
  triggerNotification: false,
}

const LabOrdersSlice = createSlice({
  name: 'labOrders',
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<number>) => {
      state.selectedTab = action.payload
    },
    incrementSuccessCount: (state) => {
      state.successCount = (state.successCount || 0) + 1
    },
    resetSuccessCount: (state) => {
      state.successCount = 0
    },
    setConsultationType: (state, action: PayloadAction<string>) => {
      state.consultationType = action.payload
    },
    setValidatedOrder: (
      state,
      action: PayloadAction<{
        orderNumber: string
        triggerNotification: boolean
      }>
    ) => {
      state.validatedOrderNumber = action.payload.orderNumber
      state.triggerNotification = action.payload.triggerNotification
    },
    resetValidatedOrder: (state) => {
      state.validatedOrderNumber = ''
      state.triggerNotification = false
    },
  },
})

// Selectors
export const selectSuccessCount = (state: any) => state?.labOrders?.successCount
export const selectConsultationType = (state: any) =>
  state?.labOrders?.consultationType
export const selectValidatedOrderNumber = (state: any) =>
  state?.labOrders?.validatedOrderNumber
export const selectTriggerNotification = (state: any) =>
  state?.labOrders?.triggerNotification

export const {
  setSelectedTab,
  incrementSuccessCount,
  resetSuccessCount,
  setConsultationType,
  setValidatedOrder,
  resetValidatedOrder,
} = LabOrdersSlice.actions

export default LabOrdersSlice.reducer
